<template>
  <div class="empty">
    <img src="@assets/img/index/noMore.png" alt="empty" class="icon">
    <div class="msg">
      <p>暂无权限</p>
      <span>请联系管理员开通权限</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'empty',
}
</script>

<style lang="less" scoped>
  @import '../assets/css/global.less';

  .empty {
    width: 100%;
    height: 220px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 90px;
    margin-bottom: 73px;

    .icon {
      width: 290px;
      height: 181px;
      margin-bottom: 14px;
    }
    .msg {
      display: flex;
      flex-direction: column;
      align-items: center;

      p {
          font-size: 20px;
          line-height: 40px;
          font-weight: bold;
          color: #050F0F;
          margin: 14px 0 2px;
      }

      span {
          display: block;
          font-size: 14px;
          line-height: 20px;
          color: #829191;
      }
    }
  }
</style>
